var _circle, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestifyWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.16663,
    cy: 10,
    r: 1.66667,
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8.33333,
    r: 1.66667,
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8334,
    cy: 4.16667,
    r: 1.66667,
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 14.1663C5.0871 14.1663 5.83362 14.9129 5.83362 15.8333V17.5003H2.49963V15.8333C2.49963 14.9129 3.24615 14.1663 4.16663 14.1663Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4997C10.9205 12.4997 11.667 13.2462 11.667 14.1667V17.4997H8.33301V14.1667C8.33301 13.2462 9.07953 12.4997 10 12.4997Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 8.33301C16.7538 8.33301 17.5004 9.07953 17.5004 10V17.5H14.1664V10C14.1664 9.07953 14.9129 8.33301 15.8334 8.33301Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestifyWt);
export default __webpack_public_path__ + "static/media/InvestifyWT.5410a5d62f44b01c0f0430b1bdb199c3.svg";
export { ForwardRef as ReactComponent };